var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return this.$ekmtcCommon.isNotEmpty(_vm.detailList)
    ? _c("div", { staticClass: "location_detail_box" }, [
        _c("div", { staticClass: "location_detail_header" }, [
          _c("div", {}, [
            _c("div", { staticClass: "ship_num" }, [
              _vm._v(_vm._s(_vm.detailParams.cntrNo)),
            ]),
            _vm.messageRk == 1
              ? _c("div", {
                  staticClass: "ship_txt",
                  domProps: { innerHTML: _vm._s(this.getMessage(_vm.msgVo)) },
                })
              : _vm.messageRk == 5
              ? _c("div", {
                  staticClass: "ship_txt",
                  domProps: { innerHTML: _vm._s(this.getMessage(_vm.msgVo)) },
                })
              : _vm.messageRk >= 7 && _vm.messageRk <= 9
              ? _c("div", {
                  staticClass: "ship_txt",
                  domProps: { innerHTML: _vm._s(this.getMessage(_vm.msgVo)) },
                })
              : _vm.messageRk >= 10 && _vm.messageRk <= 11
              ? _c("div", [
                  _vm.msgVo.ctrCd === "IN" &&
                  _vm.msgVo.plcCd == _vm.msgVo.podPortCd &&
                  _vm.msgVo.podPortCd != _vm.msgVo.dlyPlcCd &&
                  _vm.messageRk == 10
                    ? _c("div", { staticClass: "ship_txt" }, [
                        _vm._v(" " + _vm._s(_vm.$t("msg.CART010G010.058"))),
                      ])
                    : _vm.msgVo.plcCd == _vm.msgVo.podPortCd &&
                      _vm.msgVo.podPortCd != _vm.msgVo.dlyPlcCd &&
                      _vm.messageRk == 10
                    ? _c("div", {
                        staticClass: "ship_txt",
                        domProps: {
                          innerHTML: _vm._s(this.getMessage(_vm.msgVo)),
                        },
                      })
                    : _c("div", {
                        domProps: {
                          innerHTML: _vm._s(this.getMessage(_vm.msgVo)),
                        },
                      }),
                ])
              : _c("div", [
                  _vm.msgVo.ctrCd === "IN" &&
                  _vm.msgVo.plcCd == _vm.msgVo.podPortCd &&
                  _vm.msgVo.podPortCd != _vm.msgVo.dlyPlcCd &&
                  _vm.messageRk == 3
                    ? _c("div", [
                        _vm._v(" " + _vm._s(_vm.$t("msg.CART010G010.059"))),
                      ])
                    : _c("div", {
                        domProps: {
                          innerHTML: _vm._s(this.getMessage(_vm.msgVo)),
                        },
                      }),
                ]),
          ]),
          _c("div", [
            this.$ekmtcCommon.isNotEmpty(_vm.averageParams) &&
            this.$ekmtcCommon.isNotEmpty(_vm.detailInlandList)
              ? _c("div", { staticClass: "ship_time" }, [
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.averageParams.podPortNm) +
                        "(" +
                        _vm._s(_vm.averageParams.podPortCd) +
                        ") - " +
                        _vm._s(_vm.averageParams.dlyPlcNm)
                    ),
                  ]),
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("msg.CART010G010.057")) + " "),
                    _c("span", [_vm._v(_vm._s(_vm.averageParams.avgTnsDrtm))]),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]),
        _c(
          "ul",
          { staticClass: "location_detail" },
          [
            _c(
              "li",
              {
                class: [_vm.rank < 3 ? "active" : ""],
                style:
                  _vm.detailParams.cntrTypCd !== "TK"
                    ? "display: block;"
                    : "display: none;",
              },
              [
                _c("div", { staticClass: "ico ico_pickup" }, [
                  _vm._v("pickup"),
                ]),
                _c("div", { staticClass: "txt" }, [_vm._v(" Pick Up ")]),
                _c("div", { staticClass: "ts_scroll" }, [
                  _c("div", [
                    _vm._m(0),
                    _c("p", { staticClass: "date" }, [
                      _vm._v(
                        _vm._s(
                          this.$ekmtcCommon.changeDatePattern(
                            _vm.step01.mvntDt,
                            "-"
                          )
                        ) + " "
                      ),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            this.$ekmtcCommon.changeTimePattern(
                              _vm.step01.mvntTm,
                              ":"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
            _c(
              "li",
              {
                class: [
                  _vm.rank >= 3
                    ? ""
                    : _vm.step02 !== undefined &&
                      Object.keys(_vm.step02).length > 0
                    ? "active"
                    : "inactive",
                ],
              },
              [
                _c("div", { staticClass: "ico ico_loading" }, [
                  _vm._v("loading"),
                ]),
                _c(
                  "div",
                  { staticClass: "txt" },
                  [
                    _vm.isPorGateIn
                      ? [_vm._v("Place of "), _c("br"), _vm._v("Receipt")]
                      : [_vm._v("Port of "), _c("br"), _vm._v("Loading")],
                  ],
                  2
                ),
                _c("div", { staticClass: "ts_scroll" }, [
                  _c("div", [
                    _c("p", [
                      _vm._v(_vm._s(_vm.fullEmptyLabel) + " "),
                      _c("br"),
                      _vm._v(" Gate In "),
                    ]),
                    _c("p", { staticClass: "date" }, [
                      _vm._v(
                        _vm._s(
                          this.$ekmtcCommon.changeDatePattern(
                            _vm.step02.mvntDt,
                            "-"
                          )
                        ) + " "
                      ),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            this.$ekmtcCommon.changeTimePattern(
                              _vm.step02.mvntTm,
                              ":"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
            _c(
              "li",
              {
                class: [
                  _vm.rank > 4
                    ? ""
                    : _vm.step03 !== undefined &&
                      Object.keys(_vm.step03).length > 0
                    ? "active"
                    : "inactive",
                ],
              },
              [
                _c("div", { staticClass: "ico ico_board" }, [_vm._v("board")]),
                _c("div", { staticClass: "txt" }, [_vm._v(" On Board ")]),
                _c("div", { staticClass: "ts_scroll" }, [
                  _c("div", [
                    _c("p", [_vm._v("Loading")]),
                    _c("p", { staticClass: "date" }, [
                      _vm._v(
                        _vm._s(
                          this.$ekmtcCommon.changeDatePattern(
                            _vm.step03.mvntDt,
                            "-"
                          )
                        ) + " "
                      ),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            this.$ekmtcCommon.changeTimePattern(
                              _vm.step03.mvntTm,
                              ":"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
            _c(
              "li",
              {
                class: [
                  _vm.tsList.length > 0
                    ? _vm.rank === 6
                      ? "active"
                      : ""
                    : "inactive",
                ],
                style:
                  _vm.tsList.length > 0 && _vm.detailParams.cntrTypCd !== "TK"
                    ? "display: block;"
                    : "display: none;",
              },
              [
                _c("div", { staticClass: "ico ico_transhipped" }, [
                  _vm._v("transhipped"),
                ]),
                _c("div", { staticClass: "txt" }, [_vm._v(" (Transhipped) ")]),
                _c("div", { staticClass: "ts_scroll" }, [
                  _c(
                    "div",
                    {
                      key: _vm.tsInfo.rkCode,
                      attrs: {
                        "v-if":
                          _vm.tsList.length > 0 &&
                          _vm.tsInfo.cntrMvntCd === "TS",
                      },
                    },
                    [
                      _c("p", [
                        _vm._v(" T/S " + _vm._s(_vm.tsInfo.tsIdx + 1) + " "),
                        _c("br"),
                        _vm._v(" " + _vm._s(_vm.cntrStsNm) + " "),
                      ]),
                      _c("p", { staticClass: "date" }, [
                        _vm._v(
                          _vm._s(
                            this.$ekmtcCommon.changeDatePattern(
                              _vm.tsInfo.mvntDt,
                              "-"
                            )
                          ) + " "
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              this.$ekmtcCommon.changeTimePattern(
                                _vm.tsInfo.mvntTm,
                                ":"
                              )
                            )
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      class: [
                        _vm.tsInfo.tsIdx === 0
                          ? "btns prev disabled"
                          : "btns prev",
                      ],
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.preInfo(_vm.tsInfo.tsIdx, "TS")
                        },
                      },
                    },
                    [_vm._v("이전")]
                  ),
                  _c(
                    "button",
                    {
                      class: [
                        _vm.tsInfo.tsIdx === _vm.tsInfo.tsCnt - 1
                          ? "btns next disabled"
                          : "btns next",
                      ],
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.nextInfo(_vm.tsInfo.tsIdx, "TS")
                        },
                      },
                    },
                    [_vm._v("다음")]
                  ),
                ]),
              ]
            ),
            _c(
              "li",
              {
                class: [
                  _vm.rank > 7 ||
                  (_vm.detailInlandList.length > 0 &&
                    (_vm.dlyCtrCd === "IN" || _vm.dlyCtrCd === "ID"))
                    ? ""
                    : "inactive",
                ],
              },
              [
                _c("div", { staticClass: "ico ico_discharging" }, [
                  _vm._v("discharging"),
                ]),
                _vm._m(1),
                _c("div", { staticClass: "ts_scroll" }, [
                  _c("div", [
                    _c("p", [_vm._v("Discharging ")]),
                    _c("p", { staticClass: "date" }, [
                      _vm._v(
                        _vm._s(
                          this.$ekmtcCommon.changeDatePattern(
                            _vm.step04.mvntDt,
                            "-"
                          )
                        ) + " "
                      ),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            this.$ekmtcCommon.changeTimePattern(
                              _vm.step04.mvntTm,
                              ":"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
            (_vm.dlyCtrCd === "IN" &&
              (_vm.inland.length > 0 || _vm.inlandListIn.length > 0)) ||
            _vm.detailParams.icdRail === "Y" ||
            _vm.detailParams.icdTruckage === "Y" ||
            _vm.cyCfsYn === "Y"
              ? [
                  _c(
                    "li",
                    {
                      class: [
                        _vm.rank > 9
                          ? ""
                          : _vm.step05 !== undefined &&
                            Object.keys(_vm.step05).length > 0
                          ? "ts_scroll active"
                          : "inactive",
                      ],
                      style:
                        _vm.detailParams.cntrTypCd !== "TK" &&
                        _vm.cyCfsYn === "N" &&
                        (_vm.detailParams.icdRail === "Y" ||
                          _vm.detailParams.icdTruckage === "Y")
                          ? "display: block;"
                          : "display: none;",
                    },
                    [
                      _c("div", { staticClass: "ico ico_train" }, [
                        _vm._v("train_off"),
                      ]),
                      _vm.isInlandRail
                        ? _c("div", { staticClass: "txt" }, [_vm._v(" Train ")])
                        : _c("div", { staticClass: "txt" }, [
                            _vm._v(" Truck "),
                          ]),
                      _c("div", { staticClass: "ts_scroll" }, [
                        _c("div", [
                          _vm.isInlandRail
                            ? _c("p", [_vm._v("Transport by Rail")])
                            : _c("p", [_vm._v("Transport by Truck")]),
                          _c("p", { staticClass: "date" }, [
                            _vm._v(
                              _vm._s(
                                this.$ekmtcCommon.changeDatePattern(
                                  _vm.step05.mvntDt,
                                  "-"
                                )
                              ) + " "
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  this.$ekmtcCommon.changeTimePattern(
                                    _vm.step05.mvntTm,
                                    ":"
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "li",
                    {
                      class: [
                        !_vm.hasIcdArrival
                          ? "inactive"
                          : _vm.rank > 9
                          ? ""
                          : "ts_scroll active",
                      ],
                      style:
                        _vm.detailParams.cntrTypCd !== "TK" &&
                        _vm.cyCfsYn === "N" &&
                        (_vm.hasIcdArrival ||
                          _vm.detailParams.icdRail === "Y" ||
                          _vm.detailParams.icdTruckage === "Y")
                          ? "display: block;"
                          : "display: none;",
                    },
                    [
                      _c("div", { staticClass: "ico ico_icd" }, [
                        _vm._v("ICD"),
                      ]),
                      _vm._m(2),
                      _c("div", { staticClass: "ts_scroll" }, [
                        _c("div", [
                          _c("p", [_vm._v("Arrival")]),
                          _c("p", { staticClass: "date" }, [
                            _vm._v(
                              _vm._s(
                                this.$ekmtcCommon.changeDatePattern(
                                  _vm.step05_1.mvntDt,
                                  "-"
                                )
                              ) + " "
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  this.$ekmtcCommon.changeTimePattern(
                                    _vm.step05_1.mvntTm,
                                    ":"
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "li",
                    {
                      class: [
                        _vm.rank > 10
                          ? ""
                          : _vm.step07 !== undefined &&
                            Object.keys(_vm.step07).length > 0
                          ? "ts_scroll active"
                          : "inactive",
                      ],
                      style:
                        _vm.detailParams.cntrTypCd === "TK"
                          ? "display: none;"
                          : "display: block;",
                    },
                    [
                      _c("div", { staticClass: "ico ico_pickup" }, [
                        _vm._v("Pick Up"),
                      ]),
                      _c("div", { staticClass: "txt" }, [_vm._v(" Pick Up ")]),
                      _c("div", { staticClass: "ts_scroll" }, [
                        _c("div", [
                          _c("p", [
                            _vm._v(_vm._s(_vm.fullEmptyLabel) + " "),
                            _c("br"),
                            _vm._v("Gate Out "),
                          ]),
                          _c("p", { staticClass: "date" }, [
                            _vm._v(
                              _vm._s(
                                this.$ekmtcCommon.changeDatePattern(
                                  _vm.step07.mvntDt,
                                  "-"
                                )
                              ) + " "
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  this.$ekmtcCommon.changeTimePattern(
                                    _vm.step07.mvntTm,
                                    ":"
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "li",
                    {
                      class: [
                        _vm.rank > 12
                          ? "active"
                          : _vm.step08 !== undefined &&
                            Object.keys(_vm.step08).length > 0
                          ? "active"
                          : "inactive",
                      ],
                      style:
                        _vm.detailParams.cntrTypCd !== "TK"
                          ? "display: block;"
                          : "display: none;",
                    },
                    [
                      _c("div", { staticClass: "ico ico_return" }, [
                        _vm._v("Return"),
                      ]),
                      _vm._m(3),
                      _c("div", { staticClass: "ts_scroll" }, [
                        _c("div", [
                          _vm._m(4),
                          _c("p", { staticClass: "date" }, [
                            _vm._v(
                              _vm._s(
                                this.$ekmtcCommon.changeDatePattern(
                                  _vm.step08.mvntDt,
                                  "-"
                                )
                              ) + " "
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  this.$ekmtcCommon.changeTimePattern(
                                    _vm.step08.mvntTm,
                                    ":"
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ]
              : [
                  _c(
                    "li",
                    {
                      class: [
                        _vm.rank > 9
                          ? ""
                          : _vm.step05 !== undefined &&
                            Object.keys(_vm.step05).length > 0
                          ? "ts_scroll active"
                          : "inactive",
                      ],
                      style:
                        _vm.detailInlandList.length > 0 && _vm.dlyCtrCd === "ID"
                          ? "display: none;"
                          : "display: block;",
                    },
                    [
                      _c("div", { staticClass: "ico ico_pickup" }, [
                        _vm._v("Gate Out"),
                      ]),
                      _vm._m(5),
                      _c("div", { staticClass: "ts_scroll" }, [
                        _c("div", [
                          _c("p", [
                            _vm._v(_vm._s(_vm.fullEmptyLabel) + " "),
                            _c("br"),
                            _vm._v("Gate Out "),
                          ]),
                          _c("p", { staticClass: "date" }, [
                            _vm._v(
                              _vm._s(
                                this.$ekmtcCommon.changeDatePattern(
                                  _vm.step05.mvntDt,
                                  "-"
                                )
                              ) + " "
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  this.$ekmtcCommon.changeTimePattern(
                                    _vm.step05.mvntTm,
                                    ":"
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "li",
                    {
                      class:
                        _vm.rank > 10
                          ? ""
                          : [
                              _vm.inland.length > 0
                                ? "ts_scroll active"
                                : "inactive",
                            ],
                      style:
                        _vm.detailInlandList.length > 0 &&
                        _vm.dlyCtrCd === "ID" &&
                        _vm.detailParams.cntrTypCd !== "TK"
                          ? "display: block;"
                          : "display: none;",
                    },
                    [
                      _c("div", { staticClass: "ico ico_train" }, [
                        _vm._v("train_off"),
                      ]),
                      _c("div", { staticClass: "txt" }, [_vm._v(" Train ")]),
                      _c("div", { staticClass: "ts_scroll" }, [
                        _vm.inlandFlag === "D"
                          ? _c("div", [
                              _c("p", [_vm._v("Inland ETD")]),
                              _c("p", { staticClass: "date" }, [
                                _vm._v(_vm._s(_vm.inlandEtdDay) + " "),
                                _c("br"),
                                _vm._v(" " + _vm._s(_vm.inlandEtdTime)),
                              ]),
                            ])
                          : _vm._e(),
                        _vm.inlandFlag === "A"
                          ? _c("div", [
                              _c("p", [_vm._v("Inland ETA")]),
                              _c("p", { staticClass: "date" }, [
                                _vm._v(_vm._s(_vm.inlandEtaDay) + " "),
                                _c("br"),
                                _vm._v(" " + _vm._s(_vm.inlandEtaTime)),
                              ]),
                            ])
                          : _vm._e(),
                        _c(
                          "button",
                          {
                            class: [
                              _vm.inlandFlag === "D"
                                ? "btns prev disabled"
                                : "btns prev",
                            ],
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.chgInlandFlag("D")
                              },
                            },
                          },
                          [_vm._v("이전")]
                        ),
                        _c(
                          "button",
                          {
                            class: [
                              _vm.inlandFlag === "A"
                                ? "btns next disabled"
                                : "btns next",
                            ],
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.chgInlandFlag("A")
                              },
                            },
                          },
                          [_vm._v("다음")]
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "li",
                    {
                      class: [_vm.rank > 10 ? "active" : "inactive"],
                      style:
                        _vm.detailParams.cntrTypCd !== "TK"
                          ? "display: block;"
                          : "display: none;",
                    },
                    [
                      _c("div", { staticClass: "ico ico_return" }, [
                        _vm._v("Return"),
                      ]),
                      _vm._m(6),
                      _c("div", { staticClass: "ts_scroll" }, [
                        _c("div", [
                          _vm._m(7),
                          _c("p", { staticClass: "date" }, [
                            _vm._v(
                              _vm._s(
                                this.$ekmtcCommon.changeDatePattern(
                                  _vm.step06.mvntDt,
                                  "-"
                                )
                              ) + " "
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  this.$ekmtcCommon.changeTimePattern(
                                    _vm.step06.mvntTm,
                                    ":"
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ],
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_vm._v("Empty"), _c("br"), _vm._v(" Gate Out")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "txt" }, [
      _vm._v(" Port of"),
      _c("br"),
      _vm._v(" Discharging "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "txt" }, [
      _vm._v(" Place of "),
      _c("br"),
      _vm._v(" Delivery "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "txt" }, [_c("div", [_vm._v("Return")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_vm._v("Empty "), _c("br"), _vm._v("Gate In")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "txt" }, [
      _vm._v(" Gate"),
      _c("br"),
      _vm._v(" Out "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "txt" }, [_c("div", [_vm._v("Return")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_vm._v("Empty "), _c("br"), _vm._v("Gate In")])
  },
]
render._withStripped = true

export { render, staticRenderFns }